import type { Effect } from '../types';
import { SkillType } from '../model/skills';
import { dmg } from '../model/game';

export const effects: Effect[] = [
  {
    type: 'effect',
    id: 'BeltStrength',
    iconId: 'armor/BeltStrength',
    tier: 2,
    carryWeight: 150,
  },
  // Burning
  // Campfire
  {
    type: 'effect',
    id: 'ChainLightning',
    iconId: 'icon/lightning_32',
    tier: 7,
    Aoe: {
      damage: dmg({ lightning: 75 }),
      backstabBonus: 1,
      radius: 8,
      ttl: 3,
      chainTargets: [2, 4],
    }
  },
  {
    type: 'effect',
    id: 'Cold',
    tier: 0,
    healthRegen: 0.5,
    staminaRegen: 0.75,
  },
  {
    type: 'effect',
    id: 'CorpseRun',
    tier: 0,
    time: 50,
    runStamina: -0.75,
    jumpStamina: -0.75,
    carryWeight: 150,
    damageModifiers: {
      blunt: 'resistant',
      pierce: 'resistant',
      slash: 'resistant',
    },
  },
  {
    type: 'effect',
    id: 'Demister',
    iconId: 'armor/BeltStrength',
    tier: 6,
    special: 'Demister',
  },
  // Encumbered
  {
    type: 'effect',
    id: 'Freezing',
    tier: 4,
    healthOverTime: [-1, 1],
    healthRegen: 0,
    staminaRegen: 0.4,
    eitrRegen: 0.4,
    damageModifiers: { fire: 'resistant' }
  },
  // Frost
  {
    type: 'effect',
    id: 'GoblinShaman_shield',
    iconId: 'creature/GoblinShaman',
    tier: 5,
    time: 40,
    absorbDamage: [100, 100],
  },
  {
    type: 'effect',
    id: 'GP_Eikthyr',
    iconId: 'resource/TrophyEikthyr',
    tier: 2,
    time: 300,
    cooldown: 1200,
    runStamina: -0.6,
    jumpStamina: -0.6,
    swimStamina: -0.6,
  },
  {
    type: 'effect',
    id: 'GP_TheElder',
    iconId: 'resource/TrophyTheElder',
    tier: 3,
    time: 300,
    cooldown: 1200,
    healthRegen: 1.3,
    damageValueModifiers: { chop: 0.6, pickaxe: 0.6 },
  },
  {
    type: 'effect',
    id: 'GP_Bonemass',
    iconId: 'resource/TrophyBonemass',
    tier: 4,
    time: 300,
    cooldown: 1200,
    blockStamina: -1,
    blockStaminaFlat: -5,
    damageModifiers: {
      blunt: 'slightlyResistant',
      pierce: 'slightlyResistant',
      slash: 'slightlyResistant',
    }
  },
  {
    type: 'effect',
    id: 'GP_Moder',
    iconId: 'resource/TrophyDragonQueen',
    tier: 5,
    time: 300,
    cooldown: 1200,
    special: 'Tailwind',
    moveSpeed: 0.1,
    carryWeight: 300,
    damageModifiers: { frost: 'resistant' }
  },
  {
    type: 'effect',
    id: 'GP_Yagluth',
    iconId: 'resource/TrophyGoblinKing',
    tier: 5,
    time: 300,
    cooldown: 1200,
    skillModifiers: { [SkillType.Farming]: 25 },
    damageValueModifier: 0.1,
  },
  {
    type: 'effect',
    id: 'GP_Queen',
    iconId: 'resource/TrophySeekerQueen',
    tier: 6,
    time: 300,
    cooldown: 1200,
    damageModifiers: { poison: 'resistant' },
    sneakStamina: -1,
    eitrRegen: 2,
  },
  {
    type: 'effect',
    id: 'GP_Fader',
    iconId: 'resource/TrophyFader',
    tier: 7,
    time: 300,
    cooldown: 1200,
    damageModifiers: { fire: 'resistant' },
    stagger: -0.5,
  },
  {
    type: 'effect',
    id: 'TrinketBlackDamageHealth',
    iconId: 'armor/TrinketBlackDamageHealth',
    tier: 5,
    time: 60,
    cooldown: 0,
    healthUpfront: 100,
    skillModifiers: { [SkillType.Clubs]: 20 },
    damageValueModifiers: { blunt: 0.1 },
  },
  {
    type: 'effect',
    id: 'TrinketBlackStamina',
    iconId: 'armor/TrinketBlackStamina',
    tier: 5,
    time: 120,
    cooldown: 0,
    blockStamina: -0.5,
    parryBonus: 0.5,
    skillModifiers: { [SkillType.Dodge]: 20 },
  },
  {
    type: 'effect',
    id: 'TrinketBronzeHealth',
    iconId: 'armor/TrinketBronzeHealth',
    tier: 2,
    time: 60,
    cooldown: 0,
    healthRegen: 1.25,
  },
  {
    type: 'effect',
    id: 'TrinketBronzeStamina',
    iconId: 'armor/TrinketBronzeStamina',
    tier: 2,
    time: 60,
    cooldown: 0,
    staminaRegen: 1.25,
  },
  {
    type: 'effect',
    id: 'TrinketCarapaceEitr',
    iconId: 'armor/TrinketCarapaceEitr',
    tier: 6,
    time: 60,
    cooldown: 0,
    eitrRegen: 1.25,
  },
  {
    type: 'effect',
    id: 'TrinketChitinSwim',
    iconId: 'armor/TrinketChitinSwim',
    tier: 6,
    time: 60,
    cooldown: 0,
    swimStamina: -0.8,
    swimSpeed: 0.5,
  },
  {
    type: 'effect',
    id: 'TrinketFlametalEitr',
    iconId: 'armor/TrinketFlametalEitr',
    tier: 7,
    time: 60,
    cooldown: 0,
    eitrUpfront: 100,
    skillModifiers: { [SkillType.ElementalMagic]: 20, [SkillType.BloodMagic]: 20 },
    eitrRegen: 1.25,
  },
  {
    type: 'effect',
    id: 'TrinketFlametalStaminaHealth',
    iconId: 'armor/TrinketFlametalStaminaHealth',
    tier: 7,
    time: 60,
    cooldown: 0,
    healthUpfront: 100,
    staminaUpfront: 100,
  },
  {
    type: 'effect',
    id: 'TrinketIronHealth',
    iconId: 'armor/TrinketIronHealth',
    tier: 3,
    time: 30,
    cooldown: 0,
    healthUpfront: 50,
    armor: 20,
  },
  {
    type: 'effect',
    id: 'TrinketIronStamina',
    iconId: 'armor/TrinketIronStamina',
    tier: 3,
    time: 30,
    cooldown: 0,
    staminaUpfront: 50,
    moveSpeed: 0.15,
  },
  {
    type: 'effect',
    id: 'TrinketScaleStaminaDamage',
    iconId: 'armor/TrinketScaleStaminaDamage',
    tier: 6,
    time: 60,
    cooldown: 0,
    staminaUpfront: 50,
    moveSpeed: 0.15,
  },
  {
    type: 'effect',
    id: 'TrinketSilverDamage',
    iconId: 'armor/TrinketSilverDamage',
    tier: 6,
    time: 30,
    cooldown: 0,
    skillModifiers: { [SkillType.Bows]: 20, [SkillType.Spears]: 20 },
    damageValueModifiers: { pierce: 0.1 },
  },
  {
    type: 'effect',
    id: 'TrinketSilverResist',
    iconId: 'armor/TrinketSilverResist',
    tier: 4,
    time: 50,
    cooldown: 0,
    damageModifiers: {
      blunt: 'slightlyResistant',
      slash: 'slightlyResistant',
      pierce: 'slightlyResistant',
    },
  },
  // Harpooned,
  {
    type: 'effect',
    id: 'Immobilized',
    iconId: 'piece/piece_trap_troll',
    tier: 6,
    time: 5,
    moveSpeed: -100,
  },
  {
    type: 'effect',
    id: 'ImmobilizedAshlands',
    iconId: 'piece/piece_trap_troll',
    tier: 7,
    time: 10,
    moveSpeed: -100,
  },
  {
    type: 'effect',
    id: 'ImmobilizedLong',
    disabled: true,
    iconId: 'piece/piece_trap_troll',
    tier: 7,
    time: 60,
    moveSpeed: -100,
  },
  // Lightning,
  // Poison,
  // Potion_...
  {
    type: 'effect',
    id: 'Puke',
    iconId: 'resource/Pukeberries',
    tier: 2,
    time: 2,
    healthRegen: 0,
    staminaRegen: 0,
    moveSpeed: -0.5,
  },
  {
    type: 'effect',
    id: 'Potion_BugRepellent',
    iconId: 'resource/MeadBugRepellent',
    tier: 3,
    time: 600,
    pheromones: {
      target: 'Deathsquito',
      flee: true,
    },
  },
  {
    type: 'effect',
    id: 'Potion_Bzerker',
    iconId: 'resource/MeadBzerker',
    tier: 3,
    time: 20,
    cooldown: 120,
    attackStamina: -0.8,
    blockStamina: -0.8,
    dodgeStamina: -0.8,
    damageModifiers: { slash: 'weak', blunt: 'weak', pierce: 'weak' },
  },
  {
    type: 'effect',
    id: 'Potion_hasty',
    iconId: 'resource/MeadHasty',
    tier: 3,
    time: 600,
    moveSpeed: 0.15,
    skillModifiers: {
      [SkillType.Run]: 10,
    },
  },
  {
    type: 'effect',
    id: 'Potion_LightFoot',
    iconId: 'resource/MeadLightfoot',
    tier: 3,
    time: 600,
    jumpStamina: -0.3,
    jumpModifier: 0.2,
  },
  {
    type: 'effect',
    id: 'Potion_strength',
    iconId: 'resource/MeadStrength',
    tier: 3,
    time: 300,
    carryWeight: 250,
    cooldown: 120,
  },
  {
    type: 'effect',
    id: 'Potion_swimmer',
    iconId: 'resource/MeadSwimmer',
    tier: 3,
    time: 300,
    swimStamina: -0.5,
  },
  {
    type: 'effect',
    id: 'Potion_tamer',
    iconId: 'resource/MeadTamer',
    tier: 3,
    time: 600,
    special: 'TameBoost',
  },
  {
    type: 'effect',
    id: 'Potion_TrollPheromones',
    iconId: 'resource/MeadTrollPheromones',
    tier: 3,
    time: 300,
    pheromones: {
      target: 'Troll',
      spawnChanceOverride: 0.25,
      spawnMinLevel: 2,
      levelUpMultiplier: 1.25,
      maxInstanceOverride: 2,
    },
  },
  {
    type: 'effect',
    id: 'Rested',
    tier: 1,
    time: 480, // +60 per comfort
    healthRegen: 1.5,
    staminaRegen: 2,
    eitrRegen: 2,
    xpModifier: 1.5,
  },
  {
    type: 'effect',
    id: 'Resting',
    tier: 1,
    healthRegen: 3,
    staminaRegen: 4,
    eitrRegen: 4,
  },
  {
    type: 'effect',
    id: 'SE_Dvergr_buff',
    iconId: 'effect/Rested',
    tier: 6,
    time: 20,
    damageValueModifier: 1.2,
  },
  {
    type: 'effect',
    id: 'SE_Dvergr_heal',
    iconId: 'effect/heal',
    disabled: true,
    tier: 6,
    time: 4,
    healthOverTime: [400, 0.5],
  },
  {
    // radius = 4.32
    type: 'effect',
    id: 'SE_Greydwarf_shaman_heal',
    iconId: 'effect/heal',
    disabled: true,
    tier: 2,
    healthOverTime: [20, 0.5],
    time: 4,
  },
  {
    type: 'effect',
    id: 'SetEffect_FenringArmor',
    iconId: 'armor/HelmetFenring',
    tier: 4,
    damageModifiers: { fire: 'resistant' },
    skillModifiers: { [SkillType.Unarmed]: 15 },
  },
  {
    type: 'effect',
    id: 'SetEffect_AshlandsMediumArmor',
    iconId: 'armor/HelmetAshlandsMediumHood',
    tier: 7,
    runStamina: -0.1,
    jumpStamina: -0.1,
    attackStamina: -0.2,
    damageValueModifiers: { pierce: 0.1 },
  },
  {
    type: 'effect',
    id: 'SetEffect_BerserkerArmor',
    iconId: 'armor/HelmetBerserkerHood',
    tier: 2,
    healthRegen: 1.3,
    staminaRegen: 1.15,
    damageValueModifiers: { slash: 0.1, chop: 0.1 },
    damageModifiers: {
      blunt: 'slightlyWeak',
      slash: 'slightlyWeak',
      pierce: 'slightlyWeak',
    },
  },
  {
    type: 'effect',
    id: 'SetEffect_BerserkerUndeadArmor',
    iconId: 'armor/HelmetBerserkerUndead',
    tier: 5,
    healthRegen: 1.2,
    staminaRegen: 1.4,
    damageValueModifiers: { blunt: 0.2, pierce: 0.2 },
    damageModifiers: {
      blunt: 'slightlyWeak',
      slash: 'slightlyWeak',
      pierce: 'slightlyWeak',
    },
  },
  {
    type: 'effect',
    id: 'SetEffect_FishingHat',
    iconId: 'armor/HelmetFishingHat',
    tier: 6,
    skillModifiers: { [SkillType.Fishing]: 20, [SkillType.Swim]: 20 },
  },
  {
    type: 'effect',
    id: 'SetEffect_MageArmor',
    iconId: 'armor/HelmetMage',
    disabled: true,
    tier: 6,
    skillModifiers: { [SkillType.ElementalMagic]: 15 },
    eitrRegen: 1.5,
  },
  {
    type: 'effect',
    id: 'SetEffect_RootArmor',
    iconId: 'armor/HelmetRoot',
    tier: 3,
    skillModifiers: { [SkillType.Bows]: 15 },
  },
  {
    type: 'effect',
    id: 'SetEffect_TrollArmor',
    iconId: 'armor/HelmetTrollLeather',
    tier: 2,
    skillModifiers: { [SkillType.Sneak]: 15 },
  },
  {
    type: 'effect',
    id: 'SetEffect_HarvesterArmor',
    iconId: 'armor/HelmetStrawHat',
    tier: 2,
    skillModifiers: { [SkillType.Farming]: 25 },
  },
  // SetEffect_WolfArmor: frost resistance
  {
    type: 'effect',
    id: 'Shelter',
    tier: 1,
    comfort: { value: 2 }
  },
  {
    type: 'effect',
    id: 'Slimed',
    tier: 6,
    time: 1,
    damageModifiers: { fire: 'veryWeak' },
    moveSpeed: -0.5,
  },
  {
    type: 'effect',
    id: 'SlowFall',
    tier: 6,
    fallDamage: 0,
  },
  {
    type: 'effect',
    id: 'Smoked',
    tier: 1,
    healthOverTime: [-2, 1],
  },
  {
    type: 'effect',
    id: 'Staff_shield',
    tier: 6,
    time: 120,
    absorbDamage: [200, 5],
  },

  // Spirit: ttl=3, interval=0.5
  {
    type: 'effect',
    id: 'Tared',
    tier: 5,
    time: 10,
    damageModifiers: {
      fire: 'veryWeak',
    },
    moveSpeed: -0.5,
  },
  {
    type: 'effect',
    id: 'SoftDeath',
    tier: 0,
    time: 600,
  },
  {
    type: 'effect',
    id: 'Warm',
    tier: 0,
    staminaRegen: 2,
    eitrRegen: 2,
  },
  {
    type: 'effect',
    id: 'Wet',
    tier: 0,
    time: 120,
    healthRegen: 0.75,
    staminaRegen: 0.85,
    eitrRegen: 0.85,
    damageModifiers: {
      fire: 'resistant',
      frost: 'weak',
      lightning: 'weak',
    }
  },
  {
    type: 'effect',
    id: 'WindRun',
    iconId: 'armor/CapeAsksvin',
    tier: 7,
    time: 0,
    windMovementModifier: 5,
  },
  {
    type: 'effect',
    id: 'Wishbone',
    iconId: 'weapon/Wishbone',
    tier: 2,
    special: 'Wishbone',
    time: 0,
  },
];
